export const SpinnerLoading = () => {
  return (
    <div className='cha_spinner-container'>
      <div className='cha_spinner spinner-border'></div>
    </div>
  );
};
